import { AxiosInstance } from 'axios';
import {
  BillConfigurationRepository,
  SaveParameter,
} from '@/model/repository/manager/bill/BillConfigurationRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): BillConfigurationRepository => ({
    get() {
      return Repository.get(`${resource}`);
    },
    save(payload) {
      return Repository.post(`${resource}`, payload);
    },
  });
